import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { ArrowUpRight, Home as HomeIcon, BookOpen, Briefcase, Mail } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Home", icon: HomeIcon },
  { to: "/blog", label: "Blog", icon: BookOpen },
  { to: "/servizi", label: "Servizi", icon: Briefcase },
  { to: "/contatti", label: "Contatti", icon: Mail },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top header — desktop completo, mobile solo logo */}
      <header
        data-testid="site-navbar"
        className={`sticky top-0 z-50 transition-colors duration-300 ${
          scrolled ? "bg-[#F5F2EB]/90 backdrop-blur-xl border-b border-[#0E2E4D]/10" : "bg-[#F5F2EB]"
        }`}
      >
        <div className="bv-container">
          <div className="flex items-center justify-between h-[78px]">
            <Logo mode="symbol" />

            {/* Desktop: 4 link al centro */}
            <nav className="hidden md:flex items-center gap-10" aria-label="Navigazione principale">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === "/"}
                  data-testid={`nav-link-${n.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `font-display font-extrabold uppercase tracking-[0.05em] text-[13px] transition-colors ${
                      isActive ? "text-[#0E2E4D]" : "text-[#0E2E4D]/70 hover:text-[#0E2E4D]"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>

            {/* Desktop: CTA Contattaci a destra */}
            <div className="hidden md:block">
              <Link
                to="/contatti#form"
                data-testid="nav-cta-contattaci"
                className="inline-flex items-center gap-2 text-white px-5 py-3 text-[12px] tracking-[0.18em] uppercase font-display font-bold transition-colors"
                style={{ backgroundColor: "#1A7A4A" }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#13633B"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#1A7A4A"; }}
              >
                Contattaci <ArrowUpRight size={14} />
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* MOBILE: Bottom Navigation Bar fissa */}
      <nav
        data-testid="mobile-bottom-nav"
        aria-label="Navigazione mobile"
        className="md:hidden fixed bottom-0 left-0 right-0 z-[9997] bg-[#0E2E4D] border-t border-white/10 shadow-[0_-4px_16px_rgba(0,0,0,0.18)]"
        style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      >
        <ul className="flex items-stretch justify-around">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <li key={n.to} className="flex-1">
                <NavLink
                  to={n.to}
                  end={n.to === "/"}
                  data-testid={`bottom-nav-${n.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] tracking-[0.12em] uppercase font-display font-bold transition-colors ${
                      isActive ? "text-[#36BFC4]" : "text-white/80"
                    }`
                  }
                >
                  <Icon size={20} strokeWidth={2} />
                  <span>{n.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
}
